export enum BookingMessageType {
  Citation = "citation",
  Warning = "warning",
  Info = "info",
}
